import { render, staticRenderFns } from "./SubCategoryListItem.vue?vue&type=template&id=076aa24c"
import script from "./SubCategoryListItem.vue?vue&type=script&lang=ts"
export * from "./SubCategoryListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports